/**
 * End Play
 * Play is over for this player — a moderator removed them, the session ended,
 * or every attempt to reconnect has failed — and the notice that says so is
 * opening (domains/notices.ts). What play had under way ends with it: a
 * moderator's call, or an invitation still waiting, which would otherwise
 * accept itself under the notice and take the player into a call, the
 * microphone on, after play (endPrivateCall, telling the server nothing: it is
 * ending the match or the socket); and the command on its way, whose answer
 * will not come (abandonCommandInFlight). The three handlers that open those
 * notices call it first, and so do the socket dropping and the player leaving
 * (services/connection-reset.ts): what was under way cannot go on without the
 * socket or the match either.
 *
 * A module of its own, which the stores whose handlers call it import:
 * notices.ts reads those stores as it runs, and a store that imported
 * notices.ts back for this made a cycle in which notices.ts ran before a store
 * it read existed, and the game did not start (import-read-before-evaluated).
 */

import { abandonCommandInFlight } from './command-gate';
import { endPrivateCall } from './private-voice-chat';

export function endPlay(): void {
  endPrivateCall({ tellServer: false });
  abandonCommandInFlight();
}
